const LETTERBOX_ASPECT_THRESHOLD = 0.02;

export const hasVideoLetterbox = (
  videoWidth: number,
  videoHeight: number,
  stageWidth: number,
  stageHeight: number,
): boolean => {
  if (
    videoWidth <= 0 ||
    videoHeight <= 0 ||
    stageWidth <= 0 ||
    stageHeight <= 0
  ) {
    return false;
  }

  const videoAspect = videoWidth / videoHeight;
  const stageAspect = stageWidth / stageHeight;
  return Math.abs(videoAspect - stageAspect) > LETTERBOX_ASPECT_THRESHOLD;
};
